import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../../application/security/authentication.service';

@Component({
             selector: 'app-logout',
             template: ''
           })
export class LogoutComponent implements OnInit {

  static readonly LOGOUT_URL = 'logout';

  constructor(private authenticationService: AuthenticationService) {
  }

  public ngOnInit(): void {
    this.authenticationService.logout();
  }

}
